/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Hero_LeadInputs */

const es_l6_hero_lead = /** @type {(inputs: L6_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya está en Lista 6ª? Llévalo a la plataforma con la comisión más baja de la categoría y gestiona todas tus reservas en un solo sitio.`)
};

const gl_l6_hero_lead = /** @type {(inputs: L6_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xa está na Lista 6ª? Lévao á plataforma coa comisión máis baixa da categoría e xestiona todas as túas reservas nun só sitio.`)
};

const en_l6_hero_lead = /** @type {(inputs: L6_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already on List 6? Bring it to the platform with the category's lowest commission and manage all bookings in one place.`)
};

/**
* | output |
* | --- |
* | "Already on List 6? Bring it to the platform with the category's lowest commission and manage all bookings in one place." |
*
* @param {L6_Hero_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_hero_lead = /** @type {((inputs?: L6_Hero_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Hero_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_hero_lead(inputs)
	if (locale === "en") return en_l6_hero_lead(inputs)
	return es_l6_hero_lead(inputs)
});